import { Component, OnInit } from '@angular/core';
import { IncidentsDtl } from '../shared/models/IncidentsDtl';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../api.service';
import { IncidentsDocument } from '../shared/models/IncidentsDocument';
import { ResponseFile } from '../shared/models/ResponseFile';
import { UsersSupportWrapperVO } from '../shared/models/UsersSupportWrapperVO';
import { CategoryLan } from '../shared/models/CategoryLan';
import { UsersSupportDoc } from '../shared/models/UsersSupportDoc';
import { TovpilUtilsService } from '../utils/tovpil-utils.service';
import { SecurityDocument } from '../shared/models/SecurityDocument';
import { MessageDto } from '../shared/models/MessageDto';
import { TovpilLanguageService } from '../utils/tovpil-language.service';

//declare var Quill: any;

@Component({
  selector: 'app-tovpil-incidents-review-dtl',
  templateUrl: './tovpil-incidents-review-dtl.component.html',
  providers: [MessageService, ConfirmationService],
  styleUrls: ['./tovpil-incidents-review-dtl.component.scss']
})
export class TovpilIncidentsReviewDtlComponent implements OnInit {
  uploadedFiles: any[] = [];
  lstIncidentsDtl: IncidentsDtl[];
  incidentDoc: IncidentsDocument;
  incidentDtl?: IncidentsDtl;
  usersSupportWrapper: UsersSupportWrapperVO;
  lstUsersSupportDoc: UsersSupportDoc[] = [];
  selectedUsersSupport?: UsersSupportDoc;
  usersSupport?: UsersSupportDoc;
  incidentId?: string;
  sequence?: string;
  responseFile?: ResponseFile;
  submitted: boolean;
  zoneDialog: boolean;
  prmAssignedTo?: string;
  comments?: string;
  currDate?: string;
  fromUserId?: string;
  reportType?: string;
  typeIncident?: string;
  requestType?: string;
  imageSrc: string = '';
  selectedFileName?: string;
  showRelease?: boolean;
  showAssign?: boolean;
  showNew?: boolean;
  showStatus?: string;
  showSolved?: boolean;
  showClosed?: boolean;
  showDelete?: boolean;
  showEdit?: boolean;
  rejected: boolean = false;
  funcAppDesc: string;
  severity?: string;
  priority?: string;
  spendTime?: string;
  movDate?: string;
  strDate?: Date;
  token: string;
  security: SecurityDocument;
  mngComments?: string;
  readOnlyEdit: boolean;
  msg: MessageDto;
  commentsTitle: string;
  fileNameEmpty: boolean = true;

  /** LABELS */
  translations: Record<string, string> = {};


  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private translationService: TovpilLanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService

  ) { }

  async ngOnInit() {
    this.sequence = null;
    this.showRelease = false;
    this.showAssign = false;
    this.showNew = false;
    this.showDelete = false;
    this.showSolved = false;
    this.showClosed = false;
    this.showEdit = true;
    this.readOnlyEdit = true;
    this.route.queryParams
      .subscribe(
        params => {
          this.incidentId = params.incidentId;
          this.fromUserId = params.fromUserId;
          this.prmAssignedTo = params.assignedTo;
          this.showStatus = params.showStatus;
          this.requestType = params.requestType;
          this.typeIncident = params.typeIncident;
          this.token = params.token;
        });
    if (this.token) {
      await this.getSecurity();
    }

    //this.getAllUsersSupport();
  }

  /**
   * The function `getSecurity` retrieves security data based on a provided ID and performs additional
   * operations if the data is successfully retrieved.
   */
  async getSecurity() {
    await this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        if (this.security) {
          if (this.fromUserId) {
            this.fromUserId = this.security.userId;
          }

          if (this.prmAssignedTo) {
            //this.prmAssignedTo = this.security.userId;
          }

          this.findByIncidentId(this.incidentId);
        }
      }).catch(e => {
        console.error(e);
      });
  }

  /**
  * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
  * a translation service and sets them in the `translations` variable, and then calls another function
  * `getLanguages`.
  */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(
        this.security.language,
        this.security.region
      );
      this.translations = this.translationService.getLabels();
      // await this.getLanguages();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      this.messageService.add({
        severity: "warn",
        summary: "Error",
        detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}`,
      });
      // Error al traer labels traducidos
    }
  }


  capitalizeFirstLetter(inputString) {
    if (inputString.length > 0) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    } else {
      return inputString;
    }
  }

  listIncidentsDtlById(incident: String) {
    this.apiService.listIncidentsDtlById(
      {
        "incidentId": incident

      }

    ).then(
      data => {
        this.lstIncidentsDtl = data;
        if (this.lstIncidentsDtl.length > 0 && this.incidentDoc.status == 'E') {
          this.showSolved = true;
        }
        if (this.lstIncidentsDtl.length > 0 && this.incidentDoc.status == 'S') {

          if (this.fromUserId == null && this.prmAssignedTo == null || this.fromUserId != null && this.incidentDoc.userId == this.fromUserId) {
            this.showClosed = true;
          }
        }
        if (this.lstIncidentsDtl.length > 0 && this.incidentDoc.status == 'C') {
          this.showEdit = false;
        }
        if (this.lstIncidentsDtl.length == 0 && (this.incidentDoc.status == 'N' || this.incidentDoc.status == 'L')) {
          this.showDelete = true;
        }
        //this.findUsersSupportByUserId();
        this.getAllUsersSupport();
      })
  }
  findByIncidentId(incident: String) {
    this.apiService.findByIncidentId(
      {
        "incidentId": incident
      }
    ).then(
      data => {
        this.incidentDoc = data;
        if (!this.fileNameIsEmpty(this.incidentDoc.fileName)) {
          this.fileNameEmpty = false;
        }
        if (this.incidentDoc.status.trim() == 'N' && this.prmAssignedTo == null && this.fromUserId == null) {
          this.showRelease = true;
        }
        // if ((this.incidentDoc.assignedTo == null || this.incidentDoc.assignedTo.trim() == '') && this.prmAssignedTo != null) {
        //  this.showAssign = true;
        // }
        if ((this.requestType == 'RESPONSE' || this.security.levelId == 'I') && this.incidentDoc.status!='C') {
          this.showNew = true;
        }
        if (this.incidentDoc.status == 'L') {
          this.showAssign = true;
        }
        if (this.security.levelId == "I") {
          this.readOnlyEdit = false;
        }
        this.getCategorydesc("inciRole", this.incidentDoc.funcAppli);
        this.getCategorydesc("inciTypes", this.incidentDoc.type);
        this.getCategorydesc("inciPrior", this.incidentDoc.priority);
        this.getCategorydesc("inciSever", this.incidentDoc.severity);
        this.listIncidentsDtlById(this.incidentId);
        this.mngComments = this.incidentDoc.mngComments

        //if (!this.prmAssignedTo && !this.fromUserId) {
        //  this.readOnlyEdit = false;
        //}

      })
  }
  eventCancel() {
    this.router.navigate(['incidents/review'], { queryParams: { fromUserId: this.fromUserId, assignedTo: this.prmAssignedTo, showStatus: this.showStatus, token: this.token, typeIncident: this.typeIncident, requestType: this.requestType } });
  }
  onClickDownloadFile(doc: IncidentsDocument) {
    this.apiService.getFileSantoApp(
      {
        "nameFile": doc.incidentId + '_' + doc.fileName,
        "folderId": "INCIDENTS"
      }
    ).then(
      data => {
        this.responseFile = data;
        const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = `${doc.fileName}`
        link.click();
      })
  }
  fileNameIsEmpty(name?: string) {
    let result: Boolean;
    if (name == null || name == '' || name == ' ' || name == 'null') {
      result = true;
    } else {
      result = false;
    }
    return result;
  }
  openNew() {
    if (this.rejected) {
      this.commentsTitle = "Ingrese motivo del rechazo";
    } else {
      this.commentsTitle = "Ingrese Comentarios";
      this.selectedUsersSupport = null;
    }
    this.imageSrc = null;
    this.sequence = null;
    this.selectedFileName = null;
    this.zoneDialog = true;

    this.comments = null;
    this.spendTime = null;
    this.movDate = null;
    this.strDate = null;
  }
  reject() {
    this.rejected = true;

    let lstUsr = this.lstUsersSupportDoc.filter((el) => {
      return el.userId == this.incidentDoc.assignedTo;
    });
    this.selectedUsersSupport = lstUsr[0];

    this.openNew();
  }
  hideDialog() {

    this.zoneDialog = false;
    this.submitted = false;
    this.rejected = false;
  }

  createUpdateIncidentDtl() {
    var fecha = new Date();
    if (this.selectedUsersSupport.userId != null && this.comments != null) {
      const fechaFormateada = this.datepipe.transform(fecha, 'yyyyMMdd');
      this.submitted = true;
      this.zoneDialog = false;

      if (this.sequence == null || this.sequence == '') {
        //NEW- Create
        this.apiService.createIncidentsDtl(
          {
            "key": {
              "incidentId": this.incidentId
            },
            "currDate": fechaFormateada,
            "assignedTo": this.selectedUsersSupport.userId,
            "comments": this.comments,
            "fileName": this.selectedFileName,
            "spendTime": this.spendTime,
            "movDate": this.tovpilUtils.dateToTovpilDate(this.strDate)
          }
        ).then(
          data => {
            this.incidentDtl = data;
            this.saveFile(this.incidentDtl.key.sequence);
            this.findByIncidentId(this.incidentId);
          })



      } else {
        //update
        this.apiService.updateIncidentsDtl(
          {
            "key": {
              "incidentId": this.incidentId,
              "sequence": this.sequence
            },
            "currDate": this.currDate,
            "assignedTo": this.selectedUsersSupport.userId,
            "comments": this.comments,
            "fileName": this.selectedFileName,
            "spendTime": this.spendTime,
            "movDate": this.tovpilUtils.dateToTovpilDate(this.strDate),
            "mngComments": this.mngComments
          }
        ).then(
          data => {
            this.incidentDtl = data;
            this.saveFile(this.incidentDtl.key.sequence);
            this.findByIncidentId(this.incidentId);
          })


      }
      if (this.selectedUsersSupport.userId != null) {
        this.incidentDoc.assignedTo = this.selectedUsersSupport.userId;
      }

      if (this.rejected) {
        this.incidentDoc.status = 'J';
      } else {
        if (this.selectedUsersSupport.userId != null) {
          this.incidentDoc.status = 'E';
        } else {
          this.incidentDoc.status = 'L';
        }
      }
      this.incidentDoc.shortSoln = this.comments;
      this.apiService.updateIncidents(this.incidentDoc);

      this.comments = null;
      this.sequence = null;
      this.spendTime = null;
      this.movDate = null;
      this.strDate = null;

      if (this.rejected) {
        this.hideDialog();
        this.rejected = false;
        this.eventCancel();
      }
    }
  }
  edit(doc: IncidentsDtl) {

    this.selectedFileName = null;
    this.imageSrc = null;
    this.sequence = doc.key.sequence;
    if (doc.assignedTo != null) {
      this.apiService.findUsersSupportByUserId(
        {
          "userId": doc.assignedTo
        }
      ).then(
        data => {
          this.usersSupportWrapper = data;
          if (this.usersSupportWrapper.status == 'OK') {
            this.selectedUsersSupport = this.usersSupportWrapper.lstUsersSupport[0];
            this.comments = doc.comments;
            this.spendTime = doc.spendTime;
            this.movDate = doc.movDate;
            this.strDate = this.tovpilUtils.convertStringToDate(doc.movDate);
            this.currDate = doc.currDate;
            this.zoneDialog = true;
          }
        })

    }



  }
  releaseToSupport() {
    //Confirm
    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ${this.translations.lbl_release} ${this.translations.lbl_incidents}`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.changeIncidentStatus("L");

      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }
  solved() {
    //Confirm
    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ${this.translations.lbl_solution} ha sido completada`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.sendSolvedMessage();
        this.changeIncidentStatus("S");


        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }
  close() {
    //Confirm
    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ${this.translations.lbl_close} ${this.translations.lbl_incidents}`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.changeIncidentStatus("C");
        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }

  reOpen() {
    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ${this.translations.lbl_re_open} ${this.translations.lbl_incidents}`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        this.changeIncidentStatus("E");


        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }

  delete() {
    //Confirm
    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ELIMINAR la ${this.translations.lbl_incidents}`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.changeIncidentStatus("X");


        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }
  changeIncidentStatus(sts: string) {
    if (sts == "X") {
      this.incidentDoc.status = "C";
      this.incidentDoc.cancelSts = "X";
    } else {
      this.incidentDoc.status = sts;
    }
    this.apiService.updateIncidents(this.incidentDoc).then(
      data => {
        this.eventCancel();
      });
  }
  uploadEvidence(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    this.selectedFileName = file.name;

    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    let array = reader.result.split(",");
    this.imageSrc = array[1];
  }
  saveFile(seq: string) {
    //save file

    if (this.imageSrc != null) {
      this.apiService.saveFileSantoApp(
        {
          "nameFile": this.incidentId + "_" + seq + "_" + this.selectedFileName,
          "base64File": this.imageSrc,
          "folderId": "INCIDENTS"
        }
      ).then(
        data => {
        })
    }

  }
  onClickDownloadFileDtl(doc: IncidentsDtl) {

    this.apiService.getFileSantoApp(
      {
        "nameFile": doc.key.incidentId + '_' + doc.key.sequence + '_' + doc.fileName,
        "folderId": "INCIDENTS"
      }
    ).then(
      data => {
        this.responseFile = data;
        const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = `${doc.fileName}`
        link.click();
      })
  }
  assignToMyUser() {
    //confirm

    this.confirmationService.confirm({
      message: `${this.translations.lbl_wish_to_continue}?`,
      header: `${this.translations.lbl_confirm} ${this.translations.lbl_assign} ${this.translations.lbl_incidents} ${this.translations.lbl_user}?`,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action

        //this.incidentDoc.assignedTo = this.selectedUsersSupport.userId;
        this.incidentDoc.assignedTo = this.security.userId;
        this.incidentDoc.status = 'E';
        this.apiService.updateIncidents(this.incidentDoc)
          .then(
            data => {
              this.eventCancel();
            });


        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });


  }
  getAllUsersSupport() {

    if (this.requestType == null || this.requestType.trim() == '') {

      this.apiService.getAllUsersSupport().then(
        data => {
          this.usersSupportWrapper = data;

          if (this.usersSupportWrapper.status == 'OK') {
            this.lstUsersSupportDoc = this.usersSupportWrapper.lstUsersSupport;
          }
        });
    } else {

      this.apiService.findUsersSupportByUserId(
        {
          "userId": this.security.userId
        }
      ).then(
        data => {
          this.usersSupportWrapper = data;
          console.log(this.usersSupportWrapper.status);
          if (this.usersSupportWrapper.status == 'OK') {
            this.lstUsersSupportDoc = this.usersSupportWrapper.lstUsersSupport;
            this.selectedUsersSupport = this.usersSupportWrapper.lstUsersSupport[0];
          }
        });

    }
  }
  findUsersSupportByUserId() {
    //if (this.fromUserId != null) {
    this.apiService.findUsersSupportByUserId(
      {
        "userId": this.security.userId
      }
    ).then(
      data => {
        this.usersSupportWrapper = data;
        if (this.usersSupportWrapper.status == 'OK') {
          if (this.usersSupportWrapper.lstUsersSupport[0].type == 'A' || this.security.userId == this.incidentDoc.assignedTo || this.security.userId == this.incidentDoc.assignedTo) {
            this.showNew = true;
          }
        }
      })
    //} 
    //else {
    // if (this.prmAssignedTo == this.incidentDoc.assignedTo || this.fromUserId == null && this.prmAssignedTo == null) {
    //   this.showNew = true;
    //}
    //}
    if (this.incidentDoc.status == 'S' || this.incidentDoc.status == 'C') {
      this.showNew = false;
    } else {

    }
  }
  getCategorydesc(fieldId?: string, fieldVal?: string) {
    let result: string = fieldVal;
    let lstCat: CategoryLan[];
    this.apiService.getCategoryLang(
      {
        'language': "es",
        'fieldId': fieldId
      }
    ).then(
      categs => {
        lstCat = categs;
        lstCat.forEach((element) => {
          if (element.fieldVal.trim() == fieldVal) {
            if (element.descripTo != null) {
              result = element.descripTo;
            } else {
              result = element.descrip;
            }
          }
        });
        if (fieldId == "inciRole") {
          this.funcAppDesc = result;
        } else if (fieldId == "inciTypes") {
          this.reportType = result;
        } else if (fieldId == "inciPrior") {
          this.priority = result;
        } else if (fieldId == "inciSever") {
          this.severity = result;
        }
      })

  }


  updateIncident() {


    this.incidentDoc.mngComments = this.mngComments;
    this.apiService.updateIncidents(this.incidentDoc)
      .then(
        response => {
        }
      )

  }

  sendSolvedMessage() {

    this.apiService.sendMessages([{
      "subject": "Incindent " + this.incidentId + " " + this.incidentDoc.subject,
      "language": this.security.language,
      "title01": "Incidents",
      "title02": this.incidentDoc.zonCoord + " / " + this.incidentDoc.natioCoord,
      "title03": this.incidentDoc.personName,
      "paragraph01": this.incidentDoc.shortSoln,
      "freeText01": "",
      "freeText02": "Por favor, inresar a mis incidencias reportadas y si está de acuerdo con la solución presionar CERRAR",
      "senderName": "Incidents solutions",
      "emailtoReply": "NOREPLY",

      "listEmails": [this.incidentDoc.email],
      "lstFiles": []
    }])

      .then(
        response => {
        }
      )
  }

  sendEmailComment(doc: IncidentsDtl) {
    this.confirmationService.confirm({
      message: '¿Está seguro de enviar información por correo?',
      header: 'Envia email',
      icon: 'pi pi-send',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.apiService.sendMessages([{
          "subject": "Incindent " + this.incidentId + " " + this.incidentDoc.subject,
          "language": this.security.language,
          "title01": "Incidents",
          "title02": this.incidentDoc.zonCoord + " / " + this.incidentDoc.natioCoord,
          "title03": this.incidentDoc.personName,
          "paragraph01": doc.comments,
          "freeText01": "",
          "freeText02": "Por favor, ingresar a mis incidencias reportadas",
          "senderName": "Incidents solutions",
          "emailtoReply": "NOREPLY",

          "listEmails": [this.incidentDoc.email],
          "lstFiles": []
        }]).then(
          response => {
          }
        )
      }
    });
  }
}